<script>
import DatePicker from "vue2-datepicker"; // add DatePicker
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import bank_type from '../../../helpers/list/bank_type';

export default {
  components: { DatePicker },
  props: {},
  data() {
    return {
      bank_type_id: "",
      grant_name: "",
      borrower_name: "",
      received_date: "",
      amount: "",
      amount_paid: "",
      amount_remaining: "",

      //list
      list_bank_type: bank_type,
    };
  },
  validations: {
    bank_type_id: { required },
    grant_name: { required, minLength: minLength(2), maxLength: maxLength(50) },
    borrower_name: { required, minLength: minLength(2), maxLength: maxLength(50) },
    amount: { required, minLength: minLength(5), maxLength: maxLength(10) },
    amount_paid: { minLength: minLength(5), maxLength: maxLength(10) },
    amount_remaining: { minLength: minLength(5), maxLength: maxLength(10) },

    form: [
      "bank_type_id",
      "grant_name",
      "borrower_name",
      "amount",
      "amount_paid",
      "amount_remaining",
    ],
  },

  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">معلومات القرض</h5></div>
      <b-form-group class="col-md-6 mb-3" label=" نوع المصرف : " label-for="bank_type_id">
        <select
          class="form-control"
          id="bank_type_id"
          v-model="bank_type_id"
          :class="{ 'is-invalid': $v.bank_type_id.$error }"
        >
          <option value="">اختر نوع المصرف</option>
          <option v-for="bank_type in list_bank_type" :value="bank_type.id" :key="bank_type.id">{{bank_type.name}}</option>
        </select>
        <div v-if="$v.bank_type_id.$error" class="invalid-feedback">
          <span v-if="!$v.bank_type_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-6 mb-3" label="اسم المصرف : " label-for="grant_name">
        <b-form-input
          id="grant_name"
          type="text"
          placeholder="ادخل اسم المصرف"
          v-model="grant_name"
          :class="{ 'is-invalid': $v.grant_name.$error }"
        ></b-form-input>
        <div v-if="$v.grant_name.$error" class="invalid-feedback">
          <span v-if="!$v.grant_name.required">هذا الحقل الزامي</span>
          <span v-if="!$v.grant_name.minLength"
            >يجب أن يكون اسم المصرف من حرفين على الأقل</span
          >
          <span v-if="!$v.grant_name.maxLength"
            >يجب أن يكون اسم المصرف من 50 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-6 mb-3"
        label="اسم مستلم القرض : "
        label-for="borrower_name"
      >
        <b-form-input
          id="borrower_name"
          type="text"
          placeholder="ادخل اسم مستلم القرض"
          v-model="borrower_name"
          :class="{ 'is-invalid': $v.borrower_name.$error }"
        ></b-form-input>
        <div v-if="$v.borrower_name.$error" class="invalid-feedback">
          <span v-if="!$v.borrower_name.required">هذا الحقل الزامي</span>
          <span v-if="!$v.borrower_name.minLength"
            >يجب أن يكون اسم مستلم القرض من حرفين على الأقل</span
          >
          <span v-if="!$v.borrower_name.maxLength"
            >يجب أن يكون اسم مستلم القرض من 50 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-6 mb-3"
        label="تاريخ استلام القرض : "
        label-for="received_date"
      >
        <date-picker
          id="received_date"
          type="date"
          lang="ar"
          v-model="received_date"
          value-type="DD-MM-YYYY"
          format="DD-MM-YYYY"
          placeholder="اختر تاريخ استلام القرض"
        ></date-picker>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group class="col-md-4 mb-3" label=" مبلغ القرض : " label-for="amount">
        <b-form-input
          id="amount"
          type="number"
          placeholder="ادخل مبلغ القرض"
          v-model="amount"
          :class="{ 'is-invalid': $v.amount.$error }"
        ></b-form-input>
        <div v-if="$v.amount.$error" class="invalid-feedback">
          <span v-if="!$v.amount.required">هذا الحقل الزامي</span>
          <span v-if="!$v.amount.minLength"
            >يجب أن يتكون مبلغ القرض من 5 ارقام على الأقل</span
          >
          <span v-if="!$v.amount.maxLength"
            >يجب أن يتكون مبلغ القرض من 13 رقم على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-4 mb-3"
        label="المبلغ المسدد : "
        label-for="amount_paid"
      >
        <b-form-input
          id="amount_paid"
          type="number"
          placeholder="ادخل المبلغ المسدد"
          v-model="amount_paid"
          :class="{ 'is-invalid': $v.amount_paid.$error }"
        ></b-form-input>
        <div v-if="$v.amount_paid.$error" class="invalid-feedback">
          <span v-if="!$v.amount_paid.minLength"
            >يجب أن يتكون مبلغ القرض من 5 ارقام على الأقل</span
          >
          <span v-if="!$v.amount_paid.maxLength"
            >يجب أن يتكون مبلغ القرض من 13 رقم على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-4 mb-3"
        label="المبلغ المتبقي  : "
        label-for="amount_remaining"
      >
        <b-form-input
          id="amount_remaining"
          type="number"
          placeholder="ادخل المبلغ المتبقي "
          v-model="amount_remaining"
          :class="{ 'is-invalid': $v.amount_remaining.$error }"
        ></b-form-input>
        <div v-if="$v.amount.$error" class="invalid-feedback">
          <span v-if="!$v.amount_remaining.minLength"
            >يجب أن يتكون مبلغ القرض من 5 ارقام على الأقل</span
          >
          <span v-if="!$v.amount_remaining.maxLength"
            >يجب أن يتكون مبلغ القرض من 13 رقم على الاكثر</span
          >
        </div>
      </b-form-group>
    </div>
  </div>

  <!-- end page title -->
</template>
